import { useContainerMediaQuery } from '@infl-ts/util-block-width-context';
import { Box, List, ListItem, ListItemIcon, Typography } from '@mui/material';
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import * as Number from 'fp-ts/number';
import * as Ord from 'fp-ts/Ord';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from '../../external-link';
import ActionButtons from './action-buttons';
import { VisibleSocialAccount } from './codecs';
import { ListItemContainer } from './list-item-container';
import ProviderIcon from './provider-icon';
import { SocialAccountsBox } from './social-accounts-box';
import Status from './status';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SocialCard = function SocialCard(_ref) {
  var social = _ref.social,
      profileId = _ref.profileId;
  var inColumnView = useContainerMediaQuery({
    maxWidth: 'md'
  });

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(ListItem, {
    sx: {
      pl: 0
    },
    component: ListItemContainer,
    "data-element": "ListItem",
    "data-component": "SocialCard",
    "data-source-file": "social-accounts.tsx",
    children: [/*#__PURE__*/_jsx(ListItemIcon, {
      sx: {
        mb: inColumnView ? 'auto' : 0,
        ml: 2
      },
      "data-element": "ListItemIcon",
      "data-component": "SocialCard",
      "data-source-file": "social-accounts.tsx",
      children: /*#__PURE__*/_jsx(ProviderIcon, {
        social: social,
        "data-element": "ProviderIcon",
        "data-component": "SocialCard",
        "data-source-file": "social-accounts.tsx"
      })
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: inColumnView ? 'column' : 'row',
        alignItems: inColumnView ? 'start' : 'center',
        width: 1
      },
      "data-element": "Box",
      "data-source-file": "social-accounts.tsx",
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          width: inColumnView ? 1 : '35%',
          mr: 2
        },
        "data-element": "Box",
        "data-source-file": "social-accounts.tsx",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          "data-element": "Typography",
          "data-source-file": "social-accounts.tsx",
          children: social.__typename === 'OAuth2' ? t('Custom OAuth - {{socialName}}', {
            socialName: social.name
          }) : social.__typename
        }), social.connected && social.__typename !== 'Apple' && social.__typename !== 'OAuth2' && social.profileUrl && /*#__PURE__*/_jsx(ExternalLink, {
          sx: {
            fontSize: function fontSize(theme) {
              return theme.typography.body2.fontSize;
            }
          },
          target: "_blank",
          rel: "noopener noreferrer",
          href: social.profileUrl,
          children: t('Go to profile')
        })]
      }), /*#__PURE__*/_jsx(Status, {
        inColumnView: inColumnView,
        social: social,
        "data-element": "Status",
        "data-source-file": "social-accounts.tsx"
      }), /*#__PURE__*/_jsx(ActionButtons, {
        social: social,
        profileId: profileId,
        inColumnView: inColumnView,
        "data-element": "ActionButtons",
        "data-source-file": "social-accounts.tsx"
      })]
    })]
  });
};
export var ACCOUNTS_ORDER = {
  Facebook: 0,
  Twitter: 1,
  Linkedin: 2,
  Apple: 3,
  OAuth2: 4
};
var byProvider = pipe(Number.Ord, Ord.contramap(function (account) {
  return ACCOUNTS_ORDER[account.__typename];
}));

var SocialAccounts = function SocialAccounts(_ref2) {
  var socials = _ref2.socials,
      profileId = _ref2.profileId;
  return /*#__PURE__*/_jsx(SocialAccountsBox, {
    "data-element": "SocialAccountsBox",
    "data-component": "SocialAccounts",
    "data-source-file": "social-accounts.tsx",
    children: /*#__PURE__*/_jsx(List, {
      "data-element": "List",
      "data-component": "SocialAccounts",
      "data-source-file": "social-accounts.tsx",
      children: pipe(socials, A.filter(function (x) {
        return VisibleSocialAccount.is(x);
      }), A.sort(byProvider), A.map(function (social) {
        return /*#__PURE__*/_jsx(SocialCard, {
          social: social,
          profileId: profileId
        }, "".concat(social.__typename, "_").concat(social.id));
      }))
    })
  });
};

export default SocialAccounts;